module.exports = __webpack_public_path__ + "img/tema2.33cd01fb.svg";